import { isEqual } from 'lodash';

import {
    unclaimedDomainsWithCountsIsLoadingSelector,
    unclaimedFilterParamsSelector,
    unclaimedParamsSelector,
    unclaimedTotalPagesSelector,
} from '../../common/selectors/unclaimed-domains-with-counts-selectors';

import { fetchDomainsWithCounts } from '../../common/actions/domains-with-counts-action-creators';

import {
    DOMAIN_HIERARCHY_PARENT,
    DOMAIN_STATUS_UNCLAIMED,
} from '../../common/constants/definitions';

import {
    getQueryParams,
    updateQueryParam
} from '../../utils/query-param-utils';

const DEFAULT_UNCLAIMED_DOMAINS_PARAMS = {
    domainHierarchy: DOMAIN_HIERARCHY_PARENT,
    domainStatus: DOMAIN_STATUS_UNCLAIMED,
    pageNum: 1,
    pageSize: 50,
};

function fetchUnclaimedDomains( finalParams ){
    return ( dispatch ) => {
        return dispatch( fetchDomainsWithCounts( finalParams ) );
    };
}

export function fetchUnclaimedDomainsIfNeeded( params = {} ){
    // domainHierarchy determines page content, so we're storing it as a url query param
    let { domainHierarchy } = getQueryParams();

    if( !domainHierarchy ){
        domainHierarchy = DOMAIN_HIERARCHY_PARENT;
        updateQueryParam( { domainHierarchy } );
    }

    const finalParams = {
        ...DEFAULT_UNCLAIMED_DOMAINS_PARAMS,
        ...params,
    };

    return ( dispatch, getState ) => {
        const state = getState();
        const prevParams = unclaimedParamsSelector( state );
        const isLoading = unclaimedDomainsWithCountsIsLoadingSelector( state );
        const totalPages = unclaimedTotalPagesSelector( state );
        if( !isLoading &&
            !isEqual( finalParams, prevParams ) &&
            finalParams.pageNum <= totalPages
        ){
            return dispatch( fetchUnclaimedDomains( finalParams ) );
        }
        else{
            return Promise.resolve();
        }
    };
}

export function refreshUnclaimedDomains(){
    return ( dispatch, getState ) => {
        const state = getState();

        const params = unclaimedParamsSelector( state );
        const filterParams = unclaimedFilterParamsSelector( state );

        if( params ){
            // fetch first page on refresh -- the reducer handles resetting the array of ids we preserve
            const finalParams = {
                ...params,
                pageNum: 1
            };

            return dispatch( fetchUnclaimedDomains( finalParams, filterParams ) );
        }
    };
}
